module.exports = __webpack_public_path__ + "static/notification-ok-ec5b0ba9a80a76881578301a72354dd9.png";